export default __webpack_public_path__ + "static/media/king-sign.29dc3e01.svg";